function noop() {}

/**
 * The gateway mints a fresh anonymous user ID for every request that arrives without one, and the
 * browser keeps whichever Set-Cookie lands last. Parallel first-visit requests would each get a
 * different ID, so work done under one ID is orphaned when sign-in migrates another. Until an
 * identity exists, one request runs alone; the rest wait for it to finish so cookies (and any
 * registered token persistence) are in place before they go out.
 */
export function createSettledIdentityGate(hasIdentity: () => boolean) {
  let leader: Promise<void> | undefined

  return async function send<T>(request: () => Promise<T>): Promise<T> {
    while (!hasIdentity()) {
      if (leader) {
        await leader
        continue
      }

      // Derived from the request promise rather than Promise.withResolvers: the
      // first requests of a boot fire before the app's polyfills have loaded.
      const attempt = request()
      leader = attempt.then(noop, noop).finally(() => {
        leader = undefined
      })

      return attempt
    }

    return request()
  }
}
